import { useEffect, useState } from 'react';
import { useAnalytics } from '@/contexts/AnalyticsContext';
import { Button } from '@/components/ui/button';
import { Download, ExternalLink, Calendar } from 'lucide-react';
import SEO from '@/components/SEO';
const PitchDeck = () => {
  const {
    trackEvent,
    trackPageView
  } = useAnalytics();
  const [timeOnPage, setTimeOnPage] = useState(0);
  const pdfUrl = '/seniorthrive-pitch-deck.pdf';
  const meetingUrl = 'https://tidycal.com/bfluhr/thrive-30';
  useEffect(() => {
    trackPageView('/pitch-deck', 'SeniorThrive Pitch Deck');
    trackEvent('pitch_deck_viewed', {
      timestamp: new Date().toISOString(),
      referrer: document.referrer
    });
    const intervals = [30, 60, 120, 300];
    const timers = intervals.map(seconds => setTimeout(() => {
      trackEvent('pitch_deck_time_milestone', {
        seconds_on_page: seconds,
        timestamp: new Date().toISOString()
      });
    }, seconds * 1000));
    const timeInterval = setInterval(() => {
      setTimeOnPage(prev => prev + 1);
    }, 1000);
    return () => {
      timers.forEach(timer => clearTimeout(timer));
      clearInterval(timeInterval);
      trackEvent('pitch_deck_session_ended', {
        total_time_seconds: timeOnPage,
        timestamp: new Date().toISOString()
      });
    };
  }, []);
  return <>
    <SEO 
      title="SeniorThrive Pitch Deck"
      description="Empowering Older Adults to Thrive at Home"
      noindex={true}
    />
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4 py-16 max-w-5xl">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            SeniorThrive Pitch Deck
          </h1>
          <p className="text-xl text-slate-600 mb-8">
            Empowering Older Adults to Thrive at Home
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button size="lg" asChild className="gap-2 bg-blue-600 hover:bg-blue-700">
              <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                <ExternalLink className="w-5 h-5" />
                View Pitch Deck
              </a>
            </Button>
            <Button size="lg" variant="outline" asChild className="gap-2">
              <a href={pdfUrl} download="SeniorThrive-Pitch-Deck.pdf">
                <Download className="w-5 h-5" />
                Download PDF
              </a>
            </Button>
          </div>

          <div className="bg-blue-50 border-2 border-blue-200 rounded-2xl p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-slate-900 mb-3">
              Ready to Discuss?
            </h3>
            <p className="text-lg text-slate-600 mb-6">
              Schedule a 30-minute meeting with Brian Fluhr, Founder
            </p>
            <Button size="lg" asChild className="gap-2 bg-blue-600 hover:bg-blue-700">
              <a href={meetingUrl} target="_blank" rel="noopener noreferrer">
                <Calendar className="w-5 h-5" />
                Schedule Meeting with Brian
              </a>
            </Button>
          </div>
        </div>

        

        
      </div>
    </div>
  </>;
};
export default PitchDeck;